export const TEACHER_BOOK_DISCOUNT = 'TEACHER_BOOK_DISCOUNT';

export const TEACHER_BOOK_CATALOG_CREATE = 'TEACHER_BOOK_CATALOG_CREATE';

export const ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_COURSE_LIST = 'ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_COURSE_LIST';


// WEBPACK FOOTER //
// ./src/store/Admin/modules/teacherTextBookSchedule/types.js